export default __webpack_public_path__ + "cc4f72cca90745c9cd9c79ab744bd9b3.png";